import React, { useEffect, useState } from 'react';
import './ChefSpecial.css';

// import chiefSpecial0 from "../../../../assets/images/ChiefSpecial/chief-special-0.jpeg";
// import chiefSpecial1 from "../../../../assets/images/ChiefSpecial/chief-special-1.jpeg";
// import chiefSpecial2 from "../../../../assets/images/ChiefSpecial/chief-special-2.jpeg";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Autoplay, Pagination } from "swiper";
import { url } from '../../../../App';

const ChefSpecial = () => {
    const [bestItems, setBestItems] = useState([]);
    // const chefSpecialRecipies = [
    //     {
    //         id: 0,
    //         image: chiefSpecial0,
    //     },
    //     {
    //         id: 1,
    //         image: chiefSpecial1,
    //     },
    //     {
    //         id: 2,
    //         image: chiefSpecial2,
    //     },
    //     {
    //         id: 3,
    //         image: chiefSpecial1,
    //     },
    // ];
    // https://api.le-sonarga.com/content/
    useEffect(() => {
        fetch(`${url}/content/`)
            .then((res) => res.json())
            .then((jsonData) => {
                // console.log(jsonData);
                setBestItems(jsonData);
            })
    }, []);
    return (
        <section className="py-5 d-flex flex-column justify-content-center align-items-center" style={{ backgroundColor: "#021D2A" }}>
            <div className="row gx-0 pb-5 pb-md-0">
                <div className="col-12 col-md-12">
                    <div>
                    <h2 className="text-white">Meilleurs Plats</h2>
                    {/* <h6 className="text-white text-center">SPECIAL OFFERS</h6> */}
                    <div className='dish_underline'></div>
                    </div>
                </div>
            </div>
            <div className="container row gx-0">
                <div className="col-12 col-md-12">
                    <Swiper
                        spaceBetween={30}
                        slidesPerView={4}
                        pagination={{
                            clickable: true,
                        }}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: true,
                        }}
                        loop={true}
                        modules={[Autoplay, Pagination]}
                        className="best-item"
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 20,
                            },
                            480: {
                                slidesPerView: 1.5,
                                spaceBetween: 20,
                            },
                            992: {
                                slidesPerView: 4,
                                spaceBetween: 30,
                            },
                        }}
                    >
                        {
                            bestItems?.map((item, index) =>
                                <SwiperSlide key={index} className="text-white text-center py-md-5">
                                    <img src={`${url}${item?.image}`} alt="best-item" height="350" className="w-100" style={(item?.id % 2 === 0) ? { marginTop: "20px" } : { marginTop: 0 }} />
                                    <div className="pt-3 pt-md-3">
                                        <h5 style={{ color: "#ffdea0" }}>{item?.title}</h5>
                                        <h6>{item?.description}</h6>
                                        {/* <h4 style={{ color: "#ffdea0" }}>{item?.price}</h4> */}
                                    </div>
                                </SwiperSlide>
                            )
                        }
                    </Swiper>
                </div>
            </div>
        </section >
    );
};

export default ChefSpecial;